import axios from 'axios';
import qs from 'qs';
import { authInterceptor, logout } from './auth-interceptor';

const apiVersion = '/api_career/v1';

export const http = axios.create({
  baseURL: `${apiVersion}`,
  withCredentials: true,
  paramsSerializer: {
    serialize: (params) => {
      return qs.stringify(params, { arrayFormat: 'brackets' });
    },
  },
});

http.interceptors.response.use((result) => result.data);

authInterceptor(http, {
  getAccessToken: () => {
    return localStorage.getItem('apiv1Auth');
  },

  shouldLogout: (error) => {
    const { config, response: { data = {} } = {} } = error;
    return (
      config.url !== '/auth' &&
      ['err_user_deleted', 'err_suspended', 'err_token_invalid'].some((err) =>
        data?.errors?.includes?.(err)
      )
    );
  },

  shouldRefresh: (error) => {
    const {
      response: { data = {} },
    } = error;
    return data?.errors?.includes?.('err_token_expired');
  },

  logout: logout,
});
